import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";

export class UpgradeBuildingContainer extends Container {

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super();
        const upgradeIcon = new Sprite(unboardingResources.assets_views_unboarding_arrow_light_png);
        this.addChild(upgradeIcon);
        const upgradeText = new Text(`UPGRADE`, new ContainerTextStyle());
        upgradeText.style.fill = ["#01ffbe", "#26ff72"];
        upgradeText.style.fillGradientType = 1;
        upgradeText.style.fontSize = 52;
        upgradeText.angle = -5;
        upgradeText.skew.x = -0.08;
        upgradeText.position.set(287, 232);
        this.addChild(upgradeText);
        const buildingText = new Text(`THE BUILDING`, new ContainerTextStyle());
        buildingText.style.fontSize = 26;
        buildingText.angle = -5;
        buildingText.skew.x = -0.08;
        buildingText.position.set(438, 238);
        this.addChild(buildingText);
        const rankUpText = new Text(`RANK-UP`, new ContainerTextStyle());
        rankUpText.style.fill = ["#01ffbe", "#26ff72"];
        rankUpText.style.fillGradientType = 1;
        rankUpText.style.fontSize = 52;
        rankUpText.style.fontSize = 78;
        rankUpText.angle = -5;
        rankUpText.skew.x = -0.08;
        rankUpText.position.set(365, 265.5);
        this.addChild(rankUpText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78,
            fill: 'ffffff'
        });
    }
}